// extracted by mini-css-extract-plugin
export default {"txt":"story_txt__-krtL","bggradient":"story_bggradient__1BCBJ","borderBox":"story_borderBox__V2n7V"};